import type { EventName } from "@lit/react";
import { DatePicker as DatePickerElement, type DatePickerEventMap as _DatePickerEventMap, } from "@vaadin/date-picker/vaadin-date-picker.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DatePickerElement, };
export type DatePickerEventMap = Readonly<{
    onChange: EventName<_DatePickerEventMap["change"]>;
    onInvalidChanged: EventName<_DatePickerEventMap["invalid-changed"]>;
    onOpenedChanged: EventName<_DatePickerEventMap["opened-changed"]>;
    onUnparsableChange: EventName<_DatePickerEventMap["unparsable-change"]>;
    onValidated: EventName<_DatePickerEventMap["validated"]>;
    onValueChanged: EventName<_DatePickerEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInvalidChanged: "invalid-changed", onOpenedChanged: "opened-changed", onUnparsableChange: "unparsable-change", onValidated: "validated", onValueChanged: "value-changed" } as DatePickerEventMap;
export type DatePickerProps = WebComponentProps<DatePickerElement, DatePickerEventMap>;
export const DatePicker = createComponent({
    elementClass: DatePickerElement, events, react: React, tagName: "vaadin-date-picker"
});
